import { Link } from "@material-ui/core"
import API from "API"

import React from "react"

export class ErrorBoundary extends React.Component<{ api: API }, { hasError }> {
    constructor(props) {
        super(props)
        this.state = { hasError: false }
    }

    componentDidCatch(error: Error = {} as any, info: any = {}) {
        // Display fallback UI
        this.setState({ hasError: true })
        // You can also log the error to an error reporting service
        console.error("uncaught error", error, info)
        try {
            this.props.api.makeRequest({
                path: "/errors",
                method: "POST",
                body: {
                    error: {
                        message: error.message,
                        stack: error.stack
                    }, info: {
                        componentStack: info.componentStack
                    }
                }
            })
        } catch (error) {
            console.error(error)
        }
    }

    reload = () => {
        window.location.reload()
    }

    render() {
        if (this.state.hasError) {
            // You can render any custom fallback UI
            return (
                <div style={{
                    width: "100%",
                    height: "100%",
                    padding: 20,
                    backgroundColor: "white"
                }}
                >
                    <div style={{ width: "100%", padding: "10px", textAlign: "center" }}>
                        <p style={{ backgroundColor: "#f2f2f2", display: "inline-block", padding: "10px", borderRadius: "3px", color: "#4d4d4d" }}>
                            Something went wrong. <Link onClick={this.reload} underline="always">Try to reload page</Link>, please.
                        </p>
                    </div>
                </div>
            )
        }
        return this.props.children
    }
}
